"use client";

import React, { useState } from "react";
import { Button, Checkbox, Label, TextInput, Card } from "flowbite-react";
import { signIn } from "next-auth/react";

export default function LoginPage() {
  const handleKeycloakLogin = async () => {
    // Triggers the Auth.js Keycloak OAuth flow
    await signIn("keycloak", { callbackUrl: "/dashboard" });
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 p-4 dark:bg-gray-900">
      <Card className="w-full max-w-md">
        <div className="flex flex-col items-center mb-4">
          <span className="self-center whitespace-nowrap text-2xl font-bold dark:text-white">
            Welcome Back
          </span>
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
            Please sign in to your account
          </p>
        </div>

        {/* OAuth Keycloak Button */}
        <div className="flex flex-col gap-2">
          <Button 
            color="light" 
            onClick={handleKeycloakLogin} 
            className="w-full flex items-center justify-center gap-2 border-gray-300 hover:bg-gray-100"
          >
            {/* Simple representation of an OAuth/Keycloak logo key */}
            <svg className="mr-2 h-4 w-4" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M18 8a6 6 0 01-7.743 5.743L10 14l-1 1-1 1H6v2H4v2H2v-2l4.257-4.257A6 6 0 1118 8zm-6-4a1 1 0 100 2 1 1 0 000-2z" clipRule="evenodd" />
            </svg>
            Sign in with Nibious SSO
          </Button>
        </div>
      </Card>
    </div>
  );
}

